module.exports = __webpack_public_path__ + "img/nodata.77a82409.png";